import { createContext, useContext, useState, useCallback } from 'react';

const LoginModalContext = createContext(null);

export function LoginModalProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);

    const openLoginModal = useCallback(() => setIsOpen(true), []);
    const closeLoginModal = useCallback(() => setIsOpen(false), []);

    return (
        <LoginModalContext.Provider value={{ isOpen, openLoginModal, closeLoginModal }}>
            {children}
        </LoginModalContext.Provider>
    );
}

export function useLoginModal() {
    const ctx = useContext(LoginModalContext);
    if (!ctx) throw new Error('useLoginModal doit être utilisé dans <LoginModalProvider>');
    return ctx;
}